export const FETCH_LIFETIME_REQUEST = 'FETCH_LIFETIME_REQUEST';
export const FETCH_LIFETIME_SUCCESS = 'FETCH_LIFETIME_SUCCESS';
export const FETCH_LIFETIME_FAILURE = 'FETCH_LIFETIME_FAILURE';

export const UPLOAD_EMAIL_REQUEST = 'UPLOAD_EMAIL_REQUEST';
export const UPLOAD_EMAIL_SUCCESS = 'UPLOAD_EMAIL_SUCCESS';
export const UPLOAD_EMAIL_FAILURE = 'UPLOAD_EMAIL_FAILURE';

export const SEARCH_LIFETIME_REQUEST = 'SEARCH_LIFETIME_REQUEST';
export const SEARCH_LIFETIME_SUCCESS = 'SEARCH_LIFETIME_SUCCESS';
export const SEARCH_LIFETIME_FAILURE = 'SEARCH_LIFETIME_FAILURE';

export const fetchLifeTimeRequest = (page, limit) => ({
  type: FETCH_LIFETIME_REQUEST,
  payload: { page, limit },
});

export const fetchLifeTimeSuccess = (lifeTime) => ({
  type: FETCH_LIFETIME_SUCCESS,
  payload: lifeTime,
});

export const fetchLifeTimeFailure = (error) => ({
  type: FETCH_LIFETIME_FAILURE,
  payload: error,
});

export const uploadEmailRequest = (email) => ({
  type: UPLOAD_EMAIL_REQUEST,
  payload: email,
});

export const uploadEmailSuccess = () => ({
  type: UPLOAD_EMAIL_SUCCESS,
});

export const uploadEmailFailure = (error) => ({
  type: UPLOAD_EMAIL_FAILURE,
  payload: error,
});

export const searchLifeTimeRequest = (searchTerm) => ({
  type: SEARCH_LIFETIME_REQUEST,
  payload: { searchTerm },
});

export const searchLifeTimeSuccess = (lifeTime) => ({
  type: SEARCH_LIFETIME_SUCCESS,
  payload: lifeTime,
});

export const searchLifeTimeFailure = (error) => ({
  type: SEARCH_LIFETIME_FAILURE,
  payload: error,
});
